"use client";

import { Geist, Geist_Mono } from 'next/font/google'
import { Analytics } from '@vercel/analytics/next'
import { AuthProvider } from '@/components/auth-provider'
import { AuthGuard } from '@/components/auth-guard'
import { SessionGuardGate } from '@/components/session-guard-gate'
import { CompanyProvider } from '@/contexts/CompanyContext'
import { NotificationProvider } from '@/contexts/NotificationContext'
import { usePathname } from 'next/navigation'
import './globals.css'

const _geist = Geist({ subsets: ["latin"] });
const _geistMono = Geist_Mono({ subsets: ["latin"] });

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode
}>) {
  const pathname = usePathname();
  const isLoginPage = pathname.includes('/login');

  return (
    <html lang="ja">
      <head>
        <title>ドライバーアプリ</title>
        <meta name="description" content="ドライバー用アプリケーション" />
        <link rel="icon" href="/favicon.ico" />
        {/* PWAマニフェスト。ホーム画面に追加（standalone）した場合は orientation:portrait で縦固定される */}
        <link rel="manifest" href="/driver/manifest.json" />
        <meta name="theme-color" content="#2563eb" />
        {/* iOSでホーム画面起動時にstandalone（ブラウザUIなし）にする */}
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      </head>
      <body className={`font-sans antialiased`}>
        <AuthProvider>
          <CompanyProvider>
            <NotificationProvider>
              {isLoginPage ? children : <AuthGuard><SessionGuardGate>{children}</SessionGuardGate></AuthGuard>}
            </NotificationProvider>
          </CompanyProvider>
        </AuthProvider>
        <Analytics />
      </body>
    </html>
  )
}
